
import API from '../../services/client'

export default async (live)=>{
        try{
                return await API.CatalogueManager.lives.create(live)
        }catch(err){
                return err
        }
}